import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface IGameStore {
  isDemo: boolean
}

export const useGameStore = create<IGameStore>()(
  persist(
    (set) => ({
      isDemo: false,
    }),
    {
      name: 'game-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
)

// ACTIONS (setStates)
export const onChangeDemo = (checked: boolean): void => {
  useGameStore.setState({
    isDemo: checked,
  })
}

export const setIsDemo = (state: boolean): void => {
  useGameStore.setState({
    isDemo: state,
  })
}

// Selectors
const isDemoSelector = (state: IGameStore) => state.isDemo

// Getters
export const getIsDemo = () => isDemoSelector(useGameStore.getState())

// Hooks
export const useIsDemo = () => useGameStore(isDemoSelector)
